export default function navigation (document, moduleHTML, appEventEmitter) {
  const mobileNav = document.querySelector('[data-js-mobile-nav]')
  const mobileNavList = document.querySelector('[data-js-mobile-nav-list]')
  const mobileNavShade = document.querySelector('[data-js-mobile-nav-shade]')
  const mobileNavToggle = document.querySelector('[data-js-mobile-nav-toggle]')
  const mobileSubnavToggles = document.querySelectorAll('[data-js-subnav-toggle]')
  const desktopSearch = document.querySelector('[data-js-desktop-nav-search]')
  const desktopPrimaryItems = document.querySelectorAll('header nav > ul > li')

  // Fix for clicking one desktop primary item keeping it focused and overlapping as you hover over others
  desktopPrimaryItems.forEach((element) => {
    element.addEventListener('click', (event) => element.blur())
  })

  const toggleMobileNav = (event) => {
    mobileNav.classList.toggle(mobileNav.dataset.styleNavOpen)
    mobileNavList.classList.toggle(mobileNavList.dataset.styleListOpen)
    mobileNavShade.classList.toggle('hidden')
    mobileNavToggle.querySelectorAll('span').forEach((element) => {
      ['hidden', 'flex'].forEach((className) => element.classList.toggle(className))
    })
  }

  [mobileNavToggle, mobileNavShade].forEach((element) => {
    element.addEventListener('click', (event) => toggleMobileNav(event))
  })

  mobileSubnavToggles.forEach((element) => {
    element.addEventListener('click', (event) => {
      ['overflow-hidden', 'h-16', 'pb-0'].forEach((className) => element.classList.toggle(className))
      element.querySelector('svg').classList.toggle('rotate-180')
      event.stopPropagation()
    })
  })

  if ('IntersectionObserver' in window) {
    const observer = new window.IntersectionObserver(
      (elements) => {
        const isHeroVisible = (elements) => {
          // Take first element as this observer is only observing the hero
          return elements[0].isIntersecting
        }
        mobileNav.classList.toggle(mobileNav.dataset.styleCtaOpen, !isHeroVisible(elements))
        desktopSearch && desktopSearch.classList.toggle('opacity-0', isHeroVisible(elements))
      }, {
        root: null, // Document viewport
        rootMargin: '0px', // Added margin around root
        threshold: 0 // When user scrolls past the hero
      })
    // Use first section on page, which is usually the hero
    observer.observe(document.querySelector('section'))
  } else {
    // If the browser doesn't support IntersectionObserver (i.e. IE), they will always see the desktop nav search
    // Mobile IE is not really a thing so no need to do the same for the mobile CTA
    desktopSearch.classList.remove('opacity-0')
  }
}
